import React, { FC } from 'react';
import { Link } from 'react-scroll';
import Modal from '@/components/UI/modal/Modal';
import Icon from '@/components/UI/icon/Icon';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import ShareModal from '../shareModal/ShareModal';
import { getNavbarList } from '@/components/houses/_constants';
import useBookmarkToggle from '@/hooks/useBookmark';
import useDrawer from '@/hooks/useDrawer';
import styles from './NavbarDesktop.module.scss';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
type NavbarDesktopProps = {
  id: number;
};
const NavbarDesktop: FC<NavbarDesktopProps> = ({
  id
}) => {
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const handleClose = () => drawerClose();
  const {
    isBookmarked,
    toggleBookmark
  } = useBookmarkToggle(id);
  const isWhiteLabel = useIsWhiteLabel();
  return <>
      <Modal open={isDrawerOpen('SHARE')} onClose={handleClose} data-sentry-element="Modal" data-sentry-source-file="NavbarDesktop.tsx">
        <ShareModal handleClose={handleClose} data-sentry-element="ShareModal" data-sentry-source-file="NavbarDesktop.tsx" />
      </Modal>
      <Box component="section" className={styles['navbar']} data-sentry-element="Box" data-sentry-source-file="NavbarDesktop.tsx">
        <Box className={styles['navbar-wrapper']} data-sentry-element="Box" data-sentry-source-file="NavbarDesktop.tsx">
          <Box className={styles['navbar-wrapper-sections']} data-sentry-element="Box" data-sentry-source-file="NavbarDesktop.tsx">
            {getNavbarList().map(item => <Link key={item.link} activeClass={styles['active']} smooth spy offset={-130} to={item.link} className={styles['navbar-wrapper-sections-item']}>
                <Box className={styles['navbar-wrapper-sections-item-border']} />
                <Typography variant="bodyL" className={styles['navbar-wrapper-sections-item-text']}>
                  {item.title}
                </Typography>
              </Link>)}
          </Box>
          <Box className={styles['navbar-wrapper-actions']} data-sentry-element="Box" data-sentry-source-file="NavbarDesktop.tsx">
            <Box onClick={() => toggleBookmark()} className={styles['navbar-wrapper-actions-icons']} data-sentry-element="Box" data-sentry-source-file="NavbarDesktop.tsx">
              <Icon name={isBookmarked ? 'heart-Filled' : 'heart'} type={isBookmarked ? 'error' : 'highEmphasis'} data-sentry-element="Icon" data-sentry-source-file="NavbarDesktop.tsx" />
              <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="NavbarDesktop.tsx"> افزودن به علاقه مندی ها</Typography>
            </Box>
            {!isWhiteLabel && <Box onClick={() => drawerOpen('SHARE')} className={styles['navbar-wrapper-actions-icons']}>
                <Icon name={'send-2-2'} type="highEmphasis" />
                <Typography variant="bodyM">اشتراک گذاری</Typography>
              </Box>}
          </Box>
        </Box>
      </Box>
    </>;
};
export default NavbarDesktop;